import styled, { keyframes } from 'styled-components';

export const StyledCountdownWrapper = styled.div`
    position: relative;
    flex: 0 0 auto;
    width: 22px;
    height: 22px;
`;

export const StyledCountdownText = styled.div`
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
`;

export const COUNTDOWN_NUMBER_ANIMATION_MS = 160;

const countdownNumberIn = keyframes`
    from {
        transform: translateY(-60%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

const countdownNumberOut = keyframes`
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(60%);
        opacity: 0;
    }
`;

export const StyledCountdownNumber = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: transform, opacity;
`;

export const StyledCountdownCurrentNumber = styled(StyledCountdownNumber)`
    animation: ${countdownNumberIn} ${COUNTDOWN_NUMBER_ANIMATION_MS}ms ease-out both;
`;

export const StyledCountdownPrevNumber = styled(StyledCountdownNumber)`
    animation: ${countdownNumberOut} ${COUNTDOWN_NUMBER_ANIMATION_MS}ms ease-in both;
`;

const countdownStroke = keyframes`
    from {
        stroke-dashoffset: 0;
    }
    to {
        stroke-dashoffset: -100;
    }
`;

export const StyledCountdownSvg = styled.svg<{ $durationMs: number }>`
    width: 22px;
    height: 22px;
    display: block;
    transform: rotate(-90deg);

    .snackbar-countdown {
        animation: ${countdownStroke} ${({ $durationMs }) => $durationMs}ms linear forwards;
    }
`;

export const StyledCountdownCircleBg = styled.circle`
    stroke: ${({ theme }) => theme.root.colors.basicColors['4%']};
    stroke-width: 1.4px;
    fill: transparent;
`;

export const StyledCountdownCircle = styled.circle`
    stroke: ${({ theme }) => theme.root.colors.basicColors.inverted['100%']};
    stroke-width: 1.4px;
    fill: transparent;
    stroke-linecap: round;
    stroke-dasharray: 100;
    stroke-dashoffset: 0;
`;
